import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Routes from './routes/Routes';
import withTheme from './shared/hoc/withTheme';
import {initAuth} from './modules/auth/redux/actions';

import {ToastContainer} from 'react-toastify';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/DefaultTheme.scss';

const App = (props) => {
    const dispatch = useDispatch();
    const authInitialized = useSelector(state => state.Auth.authInitialized);
    const authInitializing = useSelector(state => state.Auth.authInitializing);

    useEffect(() => {
        dispatch(initAuth());
    }, [dispatch]);

    if (!authInitialized && authInitializing) {
        return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            <div>Loading...</div>
        </div>;
    }

    return (
        <div className={props.theme}>
            <Routes/>
            <ToastContainer draggable={false} autoClose={5000}/>
        </div>
    );
};

export default withTheme(App);
